import { Utils } from '../../../../providers/utils';
import { Observable } from 'rxjs/Rx';
import { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { RecipeDetailPage } from '../../pages/recipe-detail/recipe-detail';
import { CategoryBoxesCommon } from './category-boxes.common';
import { RecipeData } from '../../providers/recipe-data';
import { RecipeBoxesPage } from '../recipe-boxes/recipe-boxes';
//import { ElasticResult } from '../../../../providers/elastic-search';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeAll';
import 'rxjs/add/operator/combineLatest';
@Component({
  selector: 'category-boxes',
  templateUrl: 'category-boxes.html'
})
export class CategoryBoxesPage extends PageBase {
  public categories = [];
  public userRecipes = [];
  public loader: any;
  public filteredItems = [];
  public pagedFilteredItems: any = [];
  public pageSize: number = 3;
  public hasMore = true;
  public isFavorite = true;
  public isLoading = false;

  userId = '';
  public recipeBoxData: any;

  constructor(public nav: NavController,
    public userData: UserData,
    public settings: AppSettings,
    public events: Events,
    public common: CategoryBoxesCommon,
    private navParams: NavParams,
    public recipeData: RecipeData,
    public loadingCtrl: LoadingController,
    public recipeBoxGateway: RecipeBoxDataGateway) {
    super(settings, events, nav, userData);

  }
  ngAfterViewInit() {
    
  }

  loadPage() {
    this.isLoading = true;
    // this.pagedFilteredItems.pus
    let start: number = this.pagedFilteredItems.length;
    let pageItems = _.slice(this.filteredItems, start, start + this.pageSize);
    Array.prototype.push.apply(this.pagedFilteredItems, pageItems);

    this.hasMore = this.pagedFilteredItems.length < this.filteredItems.length;
    this.isLoading = false;
    // for (let i = 0; i < this.pageSize; i++) {
    //   if (this.pagedFilteredItems.length >= this.filteredItems.length) {
    //     this.hasMore = false;
    //     return;
    //   }
    //   this.pagedFilteredItems.push(this.filteredItems[this.pagedFilteredItems.length]);
    // }
  }
  loadMoreItems(infiniteScroll) {
    if (this.isLoading) {
      return;
    }
    this.loadPage();
    infiniteScroll.complete();
  }
  ionViewDidEnter() {
    this.loader = this.loadingCtrl.create();
    this.userId = this.currentUser ? this.currentUser.uid : null;
    this.recipeBoxData = this.recipeBoxGateway.getService(this.userId);
    this.loadData();
    
  }
  viewRecipeDetail(id) {
    this.nav.push(RecipeDetailPage, { id: id });
  }

  loadData() {
    return new Promise((resolve, reject) => {
      this.loader.present();
      this.filteredItems = [];
      this.hasMore = true;
      this.userRecipes = [];
      this.pagedFilteredItems = [];
      let stackObservable = [];
      stackObservable.push(this.getUserRecipesData());
      stackObservable.push(this.getCategoriesData());
      Observable.from(stackObservable).combineAll().subscribe(stack => {
        let userRecipe = stack[0];
        let categories = stack[1];
        _.forEach(categories, category => {
          if (category.$key) {
            let recipe = _.filter(userRecipe, (item: any) => {
              return _.find(item.categories, (itemCategory: any, key) => {
                return key == category.$key;
              });
            });
            if (recipe && recipe.length > 0) {
              category.totalRecipes = recipe.length;
            }
            else {
              category.totalRecipes = 0;
            }
          }
        });
        this.loadPage();
        this.loader.dismiss();
        resolve();
      });
    });
  }

  public getUserRecipesData() {
    return this.recipeBoxData.getUserRecipes(this.userId).map(userRecipes => {
      userRecipes = Utils.toAngularFireArray(userRecipes).reverse();
      _.forEach(userRecipes, (userRecipe: any) => {
        userRecipe.isFavorite = true;
      });
      this.userRecipes = userRecipes;
      return userRecipes;
    });
  }
  public getCategoriesData() {
    return this.recipeData.getAllCategories().map((categories) => {
      if (categories) {
        this.filteredItems = categories;
        // self.loadPage();
      }
      return categories;
    });
  }
  selectCategory(category) {
    let recipes = _.filter(this.userRecipes, item => {
      return _.find(item.categories, (itemCategory: any, key) => {
        return key == category.$key;
      });
    });
    this.nav.push(RecipeBoxesPage, { category: category, recipes: recipes });
  }
  
}


// WEBPACK FOOTER //
// ./src/modules/recipes/pages/category-boxes/category-boxes.ts